import { Badge, LuIcon, Text } from "@overmap-ai/blocks"
import { type ProcedureStepFieldValues, type Stored } from "@overmap-ai/common"
import { selectUserById } from "@overmap-ai/core"
import { Pencil } from "lucide-react"
import { memo } from "react"

import { useAppSelector } from "../../store"
import { formatCompactDate } from "../../utils/date"
import { getUserDisplayLabel } from "../../utils/users"

interface ProcedureStepFieldValuesActivityTimelineItemProps {
	procedureStepFieldValues: Stored<ProcedureStepFieldValues>
}

export const ProcedureStepFieldValuesActivityTimelineItem = memo<ProcedureStepFieldValuesActivityTimelineItemProps>(
	(props) => {
		const { procedureStepFieldValues } = props

		const createdBy = useAppSelector(selectUserById(procedureStepFieldValues.created_by ?? -1))

		return (
			<div className="flex items-center gap-4">
				<Badge icon accentColor="base" radius="full" variant="soft" size="xs">
					<LuIcon icon={Pencil} />
				</Badge>
				<Text accentColor="base" size="xs">
					<Text highContrast>{getUserDisplayLabel(createdBy)}</Text>
					&nbsp;updated field values&nbsp;&#8226;&nbsp;
					{formatCompactDate(procedureStepFieldValues.submitted_at)}
				</Text>
			</div>
		)
	},
)
ProcedureStepFieldValuesActivityTimelineItem.displayName = "ProcedureStepFieldValuesActivityTimelineItem"
